import React, { useEffect } from 'react';

const SummaryBlock = ({ allBlocks, block }) => {
    const anchors = allBlocks.filter(b => b.isAnchor);
    const summaryItems = block.content || [];

    useEffect(() => {
        // This effect can be used to sync anchors with summary items if needed
    }, [anchors, summaryItems]);

    const handleLinkClick = (e, anchorId) => {
        e.preventDefault();
        const anchorEl = document.getElementById(anchorId);
        if (anchorEl) {
            anchorEl.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <div className="p-4" style={{ textAlign: block.textAlign, fontFamily: block.fontFamily, fontSize: `${block.fontSize}px`, color: block.color }}>
            <h3 className="font-bold mb-2" style={{
                fontSize: `${block.titleFontSize || 20}px`,
                fontWeight: block.titleFontWeight || 'bold',
                color: block.titleColor || '#000000',
            }}>Sommaire</h3>
            <ul className="list-disc list-inside">
                {anchors.map(anchor => {
                    const summaryItem = summaryItems.find(item => item.anchorId === anchor.id);
                    const label = summaryItem ? summaryItem.label : anchor.content;
                    return (
                        <li key={anchor.id} style={{
                            fontSize: `${block.linksFontSize || 16}px`,
                            color: block.linksColor || '#0000FF',
                        }}>
                            <a href={`#${anchor.id}`} onClick={(e) => handleLinkClick(e, anchor.id)} className="hover:underline" style={{color: 'inherit'}}>
                                {label}
                            </a>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};

export default SummaryBlock;